module.exports = __webpack_public_path__ + "static/img/Certification7.1efa0ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Certification7.png
// module id = JaTZ
// module chunks = 1